import Commands from './commands';

class DecrBy extends Commands {
    constructor(registry) {
        super("decrBy", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const decrement = parseFloat(await emitter(node.params[1], options));
        const value = parseFloat(this.registry.get(key));
        this.registry.set(key, value - decrement);
        return value - decrement;
    }
}

export default DecrBy;
